import {IntermediatePart} from "../../intermediatePart";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {IS_BATHROOM_OLD_BV_SCENE} from "../../../../../config";

export default class ShowerHead extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_head';
    this.partName = 'Shower Head';
    this.translateId = "visualizer.bathroom.shower.shower_head";
    this.layerPriority = 4;
    this.canBeDisabled = true;
    if (isChild) {
      this.previouslySelectedFeatures = {
        Layout1: {},
        Layout4: {},
      };
    }
  }

  load(dbFeature) {
    return super.load_(dbFeature, new ShowerHead());
  }

  setLayers(layout) {

    const showerTubCombo = this.getParent().layout.parts[ShowerTubCombo.id];

    if (this.getParent().showerTubComboIsActive() && showerTubCombo && showerTubCombo.walkInTub
      && showerTubCombo.bottomTub === showerTubCombo.walkInTub.bottomTubId) {
      super.hideLayers();
      return;
    }
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  // getArrayOfConditions() {
  //   const showerParent = this.getParent();
  //   const activeShowerPartId = showerParent.showerTubComboIsActive() ? ShowerTubCombo.id : Shower.id;
  //   const showerSize = showerParent.layout.parts[activeShowerPartId].showerSize();
  //   return [{
  //     propName: "Shower",
  //     propValue: showerParent.showerTubComboIsActive()
  //       ? ["Tub"]
  //       : showerParent.isComplete() ? "Complete" : "Custom"
  //   }, {
  //     propName: 'ShowerSize',
  //     propValue: showerSize
  //   }]
  // }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerParent = this.getParent();
    if (!IS_BATHROOM_OLD_BV_SCENE) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerParent.showerSize()
      });
    }
    return conditions
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Shower.ShowerHead;
    }
  }
}
